// const ip_service = "https://190.254.16.166/RX_WEB/";
// const ip_service = "http://138.128.175.202/rx_web/";
// const ip_service = "http://192.168.132.210/rx_web/";
var ip_service = "https://resultadosutmedica.com:443/RX_WEB/";

function verificarIP() {
  return new Promise((resolve, reject) => {
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        let localIP = data.ip;
        if (localIP == "190.254.16.165") {
          ip_service = "//192.168.132.210/RX_WEB/";
          resolve()
        } else resolve()
      })
      .catch((error) => {
        console.error("Error al obtener la dirección IP:", error);
        resolve()
      });
  });
}

var instance = {
  data: () => ({
    service: ip_service,
    data_auth: sessionStorage.auth ? JSON.parse(atob(sessionStorage.auth)) : null,
    postData
  }),
};

var postData = function(dll, data, setUrl) {
  return new Promise(async (resolve, reject) => {
    var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') == -1 && navigator.userAgent.indexOf('FxiOS') == -1;
    if (!isSafari) await verificarIP()

    var url = setUrl ? dll : `${ip_service}inc/service.dll.php`;
    var formData = new FormData();
    formData.append("data", JSON.stringify(data));
    if (!setUrl) formData.append("url", dll);
    fetch(url, {
      method: "POST",
      body: formData,
    })
      .then((res) => {
        if (!res.ok) reject(res);
        return res.arrayBuffer();
      })
      .then((buffer) => {
        let decoder = new TextDecoder("iso-8859-1");
        let text = decoder.decode(buffer);
        return text;
      })
      .then((res) => {
        let encode = encodeURI(res),
          decode,
          response;
        encode = encode.replace(/%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20/g, "");
        encode = encode.replace(/%0D%0A/g, "");
        encode = encode.replace(/%0A/g, "");
        // encode = encode.replace(/%EF%BF%BD/g, "Ñ");

        decode = decodeURI(encode);
        // quita espacios - Yeisson.
        // limpia caracteres ocultos Json - Pablo.O
        decode = decode.replace(/[\u0000-\u0019]+/g, "");
        response = JSON.parse(decode.replace(/"\s+|\s+"/g, '"').replace(/Ã±/g, 'Ñ'));
        console.log(response, "RESPUESTA");

        // if (setUrl) {
        //   resolve(response);
        // } else {
          if (!response) reject(response.MENSAJE);
          else if (response.STATUS == "00") resolve(response.MENSAJE);
          else reject(response.MENSAJE);
        // }
      });
  });
};

export { instance };
